import { render } from "./referenceAbout.vue?vue&type=template&id=06f0c950&scoped=true"
import script from "./referenceAbout.vue?vue&type=script&lang=js"
export * from "./referenceAbout.vue?vue&type=script&lang=js"

import "./referenceAbout.vue?vue&type=style&index=0&id=06f0c950&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f0c950"]])

export default __exports__